import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactLoading from "react-loading";
import { FlexContainer } from "./flex_container";
import { THEME_COLOR } from "@utils/constants";

export const buttonSize = {
    small: "sm",
    large: "lg",
};

export const Button = React.forwardRef(
    (
        {
            text,
            onClick,
            type = "primary",
            icon,
            iconRight,
            image,
            color = THEME_COLOR,
            isBlock,
            isDisabled,
            size,
            isLoading,
            inverted,
            bordered,
            className,
            ...props
        },
        ref
    ) => {
        // Tryggja að takki passi fyrir myrkt þema
        const [currentTheme, setCurrentTheme] = useState("light");

        // Fylgjast með þemu breytingum
        useEffect(() => {
            // Uppfæra í byrjun
            const updateTheme = () => {
                const dataTheme = document.documentElement.getAttribute("data-theme");
                setCurrentTheme(dataTheme || "light");
            };

            // Uppfæra strax í byrjun
            if (typeof document !== "undefined") {
                updateTheme();

                // Búa til MutationObserver til að fylgjast með þemu breytingum
                const observer = new MutationObserver((mutations) => {
                    mutations.forEach((mutation) => {
                        if (
                            mutation.type === "attributes" &&
                            mutation.attributeName === "data-theme"
                        ) {
                            updateTheme();
                        }
                    });
                });

                observer.observe(document.documentElement, { attributes: true });

                return () => observer.disconnect();
            }
        }, []);

        // Nota sama lit í báðum þemum
        const buttonColor = color;
        const textColor = currentTheme === "dark" ? "white" : inverted ? color : "white";
        const isInverted = currentTheme === "dark" ? false : inverted;

        return (
            <button
                ref={ref}
                {...props}
                disabled={isDisabled || isLoading}
                style={{
                    border: bordered ? `${buttonColor} 1px solid` : "none",
                    backgroundColor: isInverted ? buttonColor + "33" : buttonColor,
                    color: textColor,
                    borderWidth: 0,
                    borderRadius: 50,
                    paddingTop: 0,
                    paddingBottom: 0,
                    whiteSpace: "nowrap",
                    ...props.style,
                }}
                onClick={onClick}
                className={classNames("btn", "custom-btn", className, {
                    [`btn-${type}`]: type,
                    [`btn-${size}`]: size,
                    "btn-block": isBlock,
                    "btn-disabled": isDisabled,
                    "dark-theme": currentTheme === "dark",
                })}
            >
                {isLoading ? (
                    <FlexContainer
                        justifyContent="center"
                        alignItems="center"
                        className="d-flex justify-content-center align-items-center text-center"
                        style={{ height: props?.style?.height || 40, position: "relative" }}
                    >
                        <ReactLoading
                            type={"bubbles"}
                            color={textColor}
                            width="100px"
                            height="100px"
                        />
                    </FlexContainer>
                ) : (
                    <>
                        {icon && <FontAwesomeIcon icon={icon} />}
                        {image && <img src={image} style={{ width: "1.2rem", height: "1.2rem" }} />}
                        {(icon || image) && text && <span style={{ marginLeft: "10px" }} />}
                        {text}

                        {iconRight && (
                            <FontAwesomeIcon icon={iconRight} style={{ marginLeft: "10px" }} />
                        )}
                    </>
                )}
            </button>
        );
    }
);

Button.displayName = "Button";
